// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [showDrawer, setShowDrawer] = useState(false);

    const handleClose = () => setShowDrawer(false);
    const handleShow = () => setShowDrawer(true);

    const Logo = () => (
        <img 
            src="https://physiodirectory.in/assets/images/logo.png" 
            alt="PhysioDir" 
            height="40"
        />
    );

    return (
        <>
            <nav className="navbar navbar-expand bg-white navbar-modern sticky-top shadow-sm py-2">
                <div className="container-fluid px-3">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        {/* Wrapper for Left side: Hamburger + Logo */}
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                className="btn btn-link link-dark p-0 border-0" 
                                onClick={handleShow}
                                style={{ fontSize: '1.5rem', textDecoration: 'none' }}
                            >
                                <i className="bi bi-list"></i>
                            </button>
                            <Link className="navbar-brand navbar-brand-modern p-0 m-0" to="/">
                                <Logo />
                            </Link>
                        </div>

                        {/* Right side: Login/Join (Visible on Nav) - REMOVED per user request */}
                        {/* 
                        <div className="d-flex align-items-center gap-2">
                            <a href="https://physiodirectory.in/login" className="btn btn-link text-decoration-none text-dark fw-bold px-2 d-none d-sm-block" style={{fontSize: '0.9rem'}}>
                                Login
                            </a>
                            <a href="https://physiodirectory.in/register" className="btn btn-dark rounded-pill px-3 py-1 fw-bold" style={{fontSize: '0.85rem', backgroundColor: '#0a1435', borderColor: '#0a1435'}}>
                                <i className="bi bi-person-plus me-1"></i> Join <span className="d-none d-sm-inline">Now</span>
                            </a>
                        </div>
                        */}
                        <div></div>
                    </div>
                </div>
            </nav>

            {/* Offcanvas Drawer */}
            <div className={`offcanvas offcanvas-start ${showDrawer ? 'show' : ''}`} 
                 tabIndex="-1" 
                 style={{
                     visibility: showDrawer ? 'visible' : 'hidden', 
                     width: '300px',
                     borderTopRightRadius: '20px',
                     borderBottomRightRadius: '20px',
                     backgroundColor: '#fff'
                 }}
            >
                <div className="offcanvas-header border-bottom p-4" style={{background: 'linear-gradient(135deg, #079ee4 0%, #0689c4 100%)'}}>
                    <div className="offcanvas-title text-white">
                        <div className="bg-white rounded p-2 d-inline-block mb-2">
                             <img 
                                src="https://physiodirectory.in/assets/images/logo.png" 
                                alt="PhysioDir" 
                                height="30"
                            />
                        </div>
                        <div className="mt-1 small opacity-75">India's Largest Physio Directory</div>
                        <button
                            className="btn fw-bold rounded-pill px-4 py-2 mt-3"
                            style={{fontSize: '1rem', background: '#0a1435', color: '#fff'}}
                            onClick={() => {
                                const url = 'https://physiodirectory.in/register';
                                if (window.ReactNativeWebView) {
                                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openExternal', url }));
                                } else {
                                    window.open(url, '_blank');
                                }
                            }}
                        >
                            Join Now
                        </button>
                    </div>
                    <button type="button" className="btn-close btn-close-white shadow-none" onClick={handleClose}></button>
                </div>
                <div className="offcanvas-body p-0">
                    <div className="list-group list-group-flush border-0 py-2">
                        <Link to="/" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                            <div className="rounded-circle bg-primary-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-house-door-fill text-primary"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">Home</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                        <Link to="/about" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                            <div className="rounded-circle bg-info-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-info-circle-fill text-info"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">About Us</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                        <Link to="/jobs" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                             <div className="rounded-circle bg-success-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-briefcase-fill text-success"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">Jobs</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                        <Link to="/shop" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                             <div className="rounded-circle bg-warning-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-cart-fill text-warning"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">Shop</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                        <Link to="/physio-help" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                             <div className="rounded-circle bg-danger-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-life-preserver text-danger"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">Physio Help</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                        <Link to="/contact" className="list-group-item list-group-item-action border-0 py-3 px-4 d-flex align-items-center" onClick={handleClose}>
                             <div className="rounded-circle bg-secondary-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'40px', height:'40px'}}>
                                <i className="bi bi-envelope-fill text-secondary"></i>
                            </div>
                            <span className="fw-medium text-dark flex-grow-1">Contact</span>
                            <i className="bi bi-chevron-right text-muted small"></i>
                        </Link>
                    </div>
                </div>

            </div>
            {/* Backdrop */}
            {showDrawer && <div className="offcanvas-backdrop fade show" onClick={handleClose}></div>}
        </>
    );
};

export default Navbar;


